import { Welcome } from "./Welcome";
import { Experience } from "./Experience";

import { Animator } from "../Common/Animator";

export function Hello({ welcome, experience}) {
  return(
    <div id="hello">
      <section className="hero is-small is-warning">
        <div className="hero-body">
          <h2 className="subtitle is-2 bf-sub-title">Hola!</h2>
        </div>
      </section>

      <Animator 
        component={<Welcome welcome={welcome}/>}
      />

      <Animator 
        component={<Experience experience={experience}/>}
      />

    </div>
  );
}